import * as $ from "jquery";

export class BBCode {
    public constructor() {
        this.initSpoilers();
        this.initAutoFormatTool();
    }

    private initSpoilers() {
        $('.spoiler-header').on('click', (evt) => {
            const outer = $(evt.currentTarget).parent();
            const content = outer.children('.spoiler-content');
            const desc = $(evt.currentTarget).find('small');

            if (content.is(':visible')) {
                content.hide();
                desc.html('(click to show)');
            } else {
                content.show();
                desc.html('(click to hide)');
            }

            return false;
        });
    }

    private initAutoFormatTool() {
        $('#auto-formatter-button').on('click', () => {
            const formatType = $('input[name=auto-formatter-type]:checked').val();
            const raw = $('#auto-formatter-input').val() as string;

            let result = null;
            if (formatType == 'list') {
                result = this.formatList(raw);
            } else if (formatType == 'table') {
                result = this.formatTable(raw);
            }

            $('#auto-formatter-output').val(result);
            return false;
        });
    }

    private formatList(raw: string): string {
        return '[list]\n[li]' + raw.replace(/\n/g, '[/li]\n[li]') + '[/li]\n[/list]';
    }

    private formatTable(raw: string): string {
        let lines = raw.split(/\r?\n/);
        lines = lines.map((s) => '[tr][td]' + s.replace(/\s*\t\s*/g, '[/td][td]') + '[/td][/tr]');
        return '[table]\n' + lines.join('\n') + '\n[/table]';
    }
}
